module.exports = __webpack_public_path__ + "static/media/feedback.f76c158a.svg";